module.exports = __webpack_public_path__ + "static/media/masteryaml.9fcf3bae.jpg";